document.addEventListener("DOMContentLoaded", function() {

    const customViewAsElement = document.getElementById("custom-view-as");
    if (customViewAsElement) {

        const darkModeKey = "grid-size";
        const htmlElement = document.querySelector("html");
        const lightModeButton = document.getElementById("grid-size-button");
        const darkModeButton = document.getElementById("grid-size-button2");
        const bigModeButton = document.getElementById("grid-size-button3");

        // Function to set active class on buttons
        function setActiveButton(activeButton, inactiveButtons) {
            // Remove active from all buttons
            [lightModeButton, darkModeButton, bigModeButton].forEach(btn => {
                if (btn) btn.classList.remove("active");
            });
            // Add active to the selected button
            if (activeButton) {
                activeButton.classList.add("active");
            }
        }

        // Initialize mode on page load based on local storage
        const gridSize = window.localStorage.getItem(darkModeKey);
        if (gridSize === "0") { // Small grid
            htmlElement.classList.add("grid-small");
            htmlElement.classList.remove("grid-medium", "grid-big");
            setActiveButton(lightModeButton);
        } else if (gridSize === "1") { // Medium grid
            htmlElement.classList.add("grid-medium");
            htmlElement.classList.remove("grid-small", "grid-big");
            setActiveButton(darkModeButton);
        } else if (gridSize === "2") { // Big grid
            htmlElement.classList.add("grid-big");
            htmlElement.classList.remove("grid-small", "grid-medium");
            setActiveButton(bigModeButton);
        } else { // Default to big grid when nothing stored
            window.localStorage.setItem(darkModeKey, "2");
            htmlElement.classList.add("grid-big");
            htmlElement.classList.remove("grid-small", "grid-medium");
            setActiveButton(bigModeButton);
        }
 
        // Function to enable small grid
        function enableLightMode() {
            window.localStorage.setItem(darkModeKey, "0");
            htmlElement.classList.remove("grid-medium", "grid-big");
            htmlElement.classList.add("grid-small");
            setActiveButton(lightModeButton);
        }

        // Function to enable medium grid
        function enableDarkMode() {
            window.localStorage.setItem(darkModeKey, "1");
            htmlElement.classList.remove("grid-small", "grid-big");
            htmlElement.classList.add("grid-medium");
            setActiveButton(darkModeButton);
        }

        // Function to enable big grid
        function enableBigMode() {
            window.localStorage.setItem(darkModeKey, "2");
            htmlElement.classList.remove("grid-small", "grid-medium");
            htmlElement.classList.add("grid-big");
            setActiveButton(bigModeButton);
        }

        // Add event listeners to buttons for toggling modes
        if (lightModeButton) lightModeButton.addEventListener("click", enableLightMode);
        if (darkModeButton) darkModeButton.addEventListener("click", enableDarkMode);
        if (bigModeButton) bigModeButton.addEventListener("click", enableBigMode);
    }
});
